import { createApp } from 'vue';
import elementPlus from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import SvgIcon from '@/components/SvgIcon';
import {
	vMoveDirectiveInit, scrollbarMouseScroll, ellipsisTitleInit,
} from '@/utils/js/Directives';

export const initAppPlugins = (app) => {
	for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
		app.component(key, component)
	}
	app.use(elementPlus, {
		locale: zhCn,
	});
	vMoveDirectiveInit(app);
	scrollbarMouseScroll(app);
	ellipsisTitleInit(app);
	return app;
}

export const vueCreateAppInit = (module, config) => {
	const app = createApp(module, config);
	return initAppPlugins(app);
}
